<template>
    <Modal
        v-model="showModal"
        title="WARNING"
        footer-hide
        class="delete-request-modal-wrapper"
        :closable="false"
        :mask-closable="false"
    >
        <div>
            <br />
            <p style="text-align: justify">
                Are you sure you want {{ message }} this request? This action cannot be undone.
            </p>
            <br />

            <Row class="confirmation-actions md-margin-top">
                <Col :xs="24" :sm="6">
                    <Button @click="handleConfirmation(false)"> CANCEL </Button>
                </Col>
                <Col :xs="24" :sm="6">
                    <Button class="pt-btn-3" :loading="isLoading" @click="handleConfirmation(true)"> YES </Button>
                </Col>
            </Row>
        </div>
    </Modal>
</template>

<script>
import { cancelSubmittedLeaveCredit } from '@/components/Requests/Dev/Leave/LeaveCredit/services/credit.services';

export default {
    data() {
        return {
            requestId: null,
            attendanceId: null,
            userId: null,
            message: '',
            showModal: false,
            isLoading: false,
        };
    },

    methods: {
        async openModal(data, mensahe) {
            this.requestId = data._id;
            this.message = mensahe;
            this.showModal = true;
        },
        handleConfirmation(status) {
            this.isLoading = true;
            if (status) {
                cancelSubmittedLeaveCredit(this.requestId)
                    .then(() => {
                        this.$Message.success(`Request credit leave ${this.message} successfully`);
                        this.$emit('create');
                        this.isLoading = false;
                        this.showModal = false;
                    })
                    .catch(() => {
                        this.$Message.error(`Failed to ${this.message} leave request`);
                        this.isLoading = false;
                    });
            } else {
                this.isLoading = false;
                this.showModal = false;
            }
        },
    },
};
</script>

<style>
.delete-request-modal-wrapper.v-transfer-dom .ivu-modal-body,
.ivu-modal-confirm {
    padding: 16px;
}
.delete-request-modal-wrapper .ivu-modal-header {
    background: none !important;
    border: none !important;
}
.delete-request-modal-wrapper .ivu-modal-header .ivu-modal-header-inner {
    color: brown !important;
}
.confirmation-actions {
    display: flex;
    align-content: space-between;
    justify-content: center;
}
</style>
